import styled from "styled-components";

import { ListPageStyled } from "Components/common/styles";

export const AdminConsoleHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
`;

export const AdminConsoleTitleStyled = styled.h1`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-weight: 600;
  font-size: 24px;
  color: #172a3f;
`;

export const UserCountStyled = styled.span`
  font-weight: 400;
  font-size: 16px;
  color: #64748b;
`;

export const HeaderControlsStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const SearchInputStyled = styled.input`
  height: 40px;
  width: 240px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  font-size: 14px;
`;

export const InviteButtonStyled = styled.button`
  height: 40px;
  padding: 0 20px;
  border: none;
  border-radius: 4px;
  background-color: #55b8b3;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: #479c98;
  }
`;

export const AdminTableStyled = styled.table`
  width: calc(100% - 64px);
  margin: 0 32px 32px;
  border-collapse: collapse;
  background-color: #ffffff;
  font-size: 14px;
  color: #172a3f;

  th {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 2px solid #e2e8f0;
    font-weight: 600;
    color: #64748b;
  }

  td {
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    vertical-align: top;
  }
`;

export const SelectStyled = styled.select`
  height: 32px;
  box-sizing: border-box;
  padding: 0 8px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 14px;
  cursor: pointer;
`;

export const ActionButtonStyled = styled.button`
  height: 32px;
  padding: 0 12px;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  background-color: #ffffff;
  font-size: 13px;
  cursor: pointer;

  &:hover {
    border-color: #55b8b3;
    color: #55b8b3;
  }
`;

export const StatusBadgeStyled = styled.span<{ $active: boolean }>`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props) => (props.$active ? "#1d7a4c" : "#9a3412")};
  background-color: ${(props) => (props.$active ? "#d6f5e3" : "#ffe8d9")};
`;

export const CompanyTagStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0 6px 6px 0;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #f1f5f9;
  font-size: 12px;
`;

export const RevokeButtonStyled = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-size: 14px;
  line-height: 1;
  color: #9a3412;
  cursor: pointer;
`;

export const EmptyStateStyled = styled.div`
  margin: 48px 32px;
  text-align: center;
  color: #64748b;
`;

export const InviteFormStyled = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin: 0 32px 24px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background-color: #f8fafc;
`;

export const InviteFieldStyled = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #64748b;

  input {
    height: 32px;
    box-sizing: border-box;
    padding: 0 8px;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    font-size: 14px;
  }
`;

export const AdminTabsStyled = styled.nav`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 16px 32px 0;
  font-size: 14px;
  font-weight: 600;

  a {
    color: #64748b;
    text-decoration: none;

    &:hover {
      color: #55b8b3;
    }
  }

  span[aria-current="page"] {
    color: #172a3f;
    border-bottom: 2px solid #55b8b3;
    padding-bottom: 2px;
  }
`;

/**
 * Admin Console page shell. `ListPageStyled` is `height: 100%` of the app
 * column, which also holds the 72px navigation bar, so the page ran 72px past
 * the viewport and its bottom (the pagination controls) was clipped by the
 * `overflow: hidden` root. Sizing to the remaining height keeps the whole
 * scroll body on screen.
 */
export const AdminPageStyled = styled(ListPageStyled)`
  height: calc(100% - 72px);
`;

/**
 * Scroll container for everything below the tabs. The page (`ListPageStyled`)
 * is a fixed-height flex column inside an `overflow: hidden` root, so without
 * this the users/history tables were clipped and unreachable when long.
 */
export const AdminConsoleBodyStyled = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
`;

export const AuditFilterFormStyled = styled(InviteFormStyled)``;

export const AuditFilterErrorStyled = styled.div`
  flex-basis: 100%;
  padding: 8px 12px;
  border-radius: 4px;
  background-color: #ffe8d9;
  color: #9a3412;
  font-size: 13px;
`;

export const AuditSnapshotStyled = styled.dl`
  margin: 0;
  font-size: 12px;
  font-family: monospace;

  div {
    display: flex;
    gap: 6px;
  }

  dt {
    color: #64748b;
  }

  dt::after {
    content: ":";
  }

  dd {
    margin: 0;
    word-break: break-all;
  }
`;

export const AuditPaginationStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 32px 32px;
  font-size: 14px;
  color: #64748b;
`;
